import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['enabledCheckbox', 'valueSelect']

  connect() {
    this.boundToggleValueSelect()
  }

  enabledCheckboxTargetConnected(element) {
    element.addEventListener('change', this.boundToggleValueSelect)
  }

  enabledCheckboxTargetDisconnected(element) {
    element.removeEventListener('change', this.boundToggleValueSelect)
  }

  toggleValueSelect(_event) {
    const checkboxEnabled = this.enabledCheckboxTarget.checked

    if (!!checkboxEnabled) {
      this.valueSelectTargets.forEach((element) => {
        element.removeAttribute('disabled')
        element.classList.toggle('d-none', false)
      })
    } else {
      this.valueSelectTargets.forEach((element) => {
        element.setAttribute('disabled', 'disabled')
        element.classList.toggle('d-none', true)
      })
    }
  }

  get boundToggleValueSelect() {
    return this.toggleValueSelect.bind(this)
  }
}
